import React from 'react';
import {SignupStep} from './SignupStep';

export default class SignupStep1 extends SignupStep {
    renderStep(): React.ReactNode {
        return <React.Fragment />;
    }
}
